import z from "zod";

export const DocumentationFormSchema = z.object({
    title: z.string(),
    parentID: z.string()
});

export const DocumentationCreationResultSchema = z.object({
    message: z.string(),
    id: z.string()
});